
<div class="container dashboard_card fm_padding dc_fixed" id="divpcontainer" *ngIf="_show">

 <div class="dc_header">
        <span></span>
        <h3>Update Digipin</h3>
        <button (click)="Close()"><i class="icon-close"></i></button>
    </div>
    
     <div class="add_cust_card" >

        <div class="acc_show_card" >
             <div class="add_cust_card acc_map_custom" id="divf_4">
  
        <div class="acmc_map_area">            
      
            <div class="right_txt_btn_card" style="margin-bottom: 12px;">

                <a href="javascript:void(0)" (click)="digipin_setMyCurrentLocation()" class="">Use My Location</a>
        
            </div>

            <div class="acc_show_card lcta_tbox error">
    
                <div class="dcb_map">
    
                    <capacitor-google-map #digipinmap></capacitor-google-map>
              
                </div> 
                    <p *ngIf="showLocationError" class="toast_card">Customer location is not within the permissible distance of the current location</p>
            </div>

        </div>
      
  
    </div>
            
        </div>
     </div>
        <button class="fixed_btn" [ngClass]="{'disable': btnSaveDisableEnable}" (click)="Savedigipin()" >SAVE</button>
  </div>


  <div class="popupu_card ci_popup_card pop_active_card"  *ngIf="divbeyondPopup">

        <div class="popup_inner">

            <a href="javascript:void(0)" (click)="divbeyondPopup=false" class="pc_close_btn"><i class="icon-close"></i></a>

            <div class="ci_popup_txt_area">

                <p class="cpta_img"><img src="assets/images/alert_icon.svg" alt=""></p>

                <p>Customer location is not within the permissible distance of the current location.</p>

                
            </div>
            <div class="ci_popup_btn_area">
                <button (click)="BeyandCancel()">CANCEL</button>

                <button (click)="BeyandYes()">YES</button>

            </div>

        </div>

    </div>